import FavoriteFinancialItemsStore from '../../Common/FavoriteFinancialItemsStore';
import NotificationBoxStore from '../../Common/NotificationBoxStore';
import FavoriteSignUpModalStore from '../../Modal/FavoriteSignUpModalStore';
import ReportFinancialItemsStore from '../../Common/ReportFinancialItemsStore';
import ReportModalStore from '../Modal/ReportModalStore';
import NameModalStore from '../Modal/NameModalStore';
/**
 * 個別銘柄ルートストア
 *
 * @module Stocks/StocksStore
 */
const StocksStore = {
  // 名前モーダル用のルートストア設定をマージする
  state: NameModalStore.state,
  getters: NameModalStore.getters,
  mutations: NameModalStore.mutations,
  modules: {
    favoriteFinancialItems: FavoriteFinancialItemsStore,
    notificationBox: NotificationBoxStore,
    favoriteSignUpModal: FavoriteSignUpModalStore,
    reportFinancialItems: ReportFinancialItemsStore,
    reportModal: ReportModalStore,
    nameModal: NameModalStore,
  },
};
export default StocksStore;
